import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createNewAccount, updateAccount } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import AccountForm from './AccountForm';

const FORM_ID = 'createAccountForm';

export class AccountFormContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number,
    createAccountAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isEdit: PropTypes.bool,
    submitting: PropTypes.bool.isRequired,
    updateAccountAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    accountId: null,
    isEdit: false,
  };

  handleAccountSubmit = params => {
    const { createAccountAction, updateAccountAction, isEdit, accountId } = this.props;
    const token = storeWithExpiration.get('token');
    const accountInfo = {
      companyName: params.companyName,
      status: params.status,
      accountTypeId: params.accountTypeId,
      creditsEnabled: params.creditsEnabled || false,
      address1: params.address1,
      address2: params.address2,
      city: params.city,
      stateProvince: params.stateProvince,
      postcode: params.postcode,
      country: params.country,
      url: params.url,
      portalHost: params.portalHost,
      phone: params.phone,
    };

    if (isEdit) updateAccountAction(token, accountInfo, accountId);
    else createAccountAction(token, accountInfo);
  };

  render() {
    const { handleSubmit, isEdit, submitting, invalid } = this.props;

    return (
      <AccountForm
        invalid={invalid}
        handleSubmit={handleSubmit}
        submitAccountFunction={this.handleAccountSubmit}
        submitting={submitting}
        isEdit={isEdit}
      />
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.companyName || values.companyName === '') {
    errors.companyName = 'Required';
  }
  if (!values.address1 || values.address1 === '') {
    errors.address1 = 'Required';
  }
  if (!values.city || values.city === '') {
    errors.city = 'Required';
  }
  if (!values.accountTypeId || values.accountTypeId === '') {
    errors.accountTypeId = 'Required';
  } else if (!/^[A-Z ]{1,40}$/i.test(values.city)) {
    errors.city = 'Invalid city format';
  }
  if (!values.stateProvince || values.stateProvince === '') {
    errors.stateProvince = 'Required';
  }
  if (!values.postcode || values.postcode === '') {
    errors.postcode = 'Required';
  }
  if (!values.country || values.country === '') {
    errors.country = 'Required';
  }
  if (!values.url || values.url === '') {
    errors.url = 'Required';
  }
  if (!values.portalHost || values.portalHost === '') {
    errors.portalHost = 'Required';
  }
  if (!values.phone || values.phone === '') {
    errors.phone = 'Required';
  } else if (!/^[0-9-() +/.]{5,20}$/i.test(values.phone)) {
    errors.phone = 'Invalid phone number format';
  }
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const { superadmin } = state;
  const { isEdit } = ownProps;
  const currAccount = superadmin.get('currAccount');
  const initialValues = isEdit
    ? {
        companyName: currAccount.get('companyName') || '',
        status: currAccount.get('status') || 0,
        accountTypeId: currAccount.get('accountTypeId') || '',
        creditsEnabled: currAccount.get('creditsEnabled') || '',
        address1: currAccount.get('address1') || '',
        address2: currAccount.get('address2') || '',
        city: currAccount.get('city') || '',
        stateProvince: currAccount.get('stateProvince') || '',
        postcode: currAccount.get('postcode') || '',
        country: currAccount.get('country') || '',
        url: currAccount.get('url') || '',
        portalHost: currAccount.get('portalHost') || '',
        phone: currAccount.get('phone') || '',
      }
    : { creditsEnabled: true };
  return { initialValues };
};

const AccountFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
  enableReinitialize: true,
})(AccountFormContainer);

export default connect(mapStateToProps, {
  createAccountAction: createNewAccount,
  updateAccountAction: updateAccount,
})(AccountFormContainerRF);
